import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { SxProps, Theme } from '@mui/material/styles';
import color from '@theme/Colors';
import { KPopup } from './useModal';

export type KModelProps = KPopup & {
    modalContent: ReactNode;
    width?: number | string;
    sx?: SxProps<Theme>;
};

export default function MyModal({ modalContent, open, handleOpen, handleClose, width, sx }: KModelProps) {
    return (
        <Box sx={{}}>
            <Modal
                open={open}
                // onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute' as 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: width ?? 'fit-content',
                        maxWidth: '90vw',
                        bgcolor: color.white,
                        gap: 4,
                        borderRadius: '10px',
                        outline: 'none',
                        ...sx,
                    }}
                    tabIndex={-1}
                    onKeyDown={(e) => {
                        if (e.key === 'Escape') {
                            e.stopPropagation();
                            handleClose();
                        }
                    }}
                >
                    {modalContent}
                </Box>
            </Modal>
        </Box>
    );
}
